export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 9,
        name_ca: 'Sí',
        name_es: 'Sí',
        name_en: 'Yes'
    }, {
        id: 3,
        name_ca: 'Poliestirè extruït',
        name_es: 'Poliestireno extruido',
        name_en: 'Extruded Polystyrene'
    }, {
        id: 4,
        name_ca: 'Poliestirè expandit',
        name_es: 'Poliestireno expandido',
        name_en: 'Expanded polystyrene'
    }, {
        id: 5,
        name_ca: 'Llana de roca',
        name_es: 'Lana de roca',
        name_en: 'Rockwool'
    }, {
        id: 6,
        name_ca: 'Llana de vidre',
        name_es: 'Lana de vidrio',
        name_en: 'Glass wool'
    }, {
        id: 7,
        name_ca: 'Poliuretà',
        name_es: 'Poliuretano',
        name_en: 'Polyurethane'
    }, {
        id: 8,
        name_ca: 'Panell sàndvitx',
        name_es: 'Panel sándwich',
        name_en: 'Sandwich panel'
    }
]





// WEBPACK FOOTER //
// ./src/options/insulations.js